// extracted by mini-css-extract-plugin
export var contentWrap = "blogContent-module--content-wrap--6915a";
export var layoutBlog = "blogContent-module--layout-blog--3526e";
export var textblockWrap = "blogContent-module--textblock-wrap--85b31";